<template>
  <div class="games">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page edit">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-12 cell">

          <bouton href="dashboard" class-bt="return">Retour au carnet de bord</bouton>

          <title-page attrpage="Mon compte" baseline="">Editer et gérer les informations de {{ first_name }}</title-page>

          <p>Cette page vous permet de gérer les informations et les notifications pour le compte de {{ first_name }}.</p>
          <hr>
        </div>

          <div class="small-12 medium-4 cell">
            <div class="form ">

              <p>Identifiant : <strong> {{ identifier }} </strong></p>

              <div :class="{error: errors.indexOf('firstname') !== -1}">
                <label for="prenom">Prénom* :</label>
                <input type="text" name="prenom" id="prenom" v-model="first_name" required />
              </div>

              <div :class="{error: errors.indexOf('lastname') !== -1}">
                <label for="nom">Nom de famille* :</label>
                <input type="text" name="nom" id="nom" v-model="last_name" required />
              </div>

              <div :class="{error: errors.indexOf('birthdate') !== -1}">
                <label for="date">Date de naissance* :</label>
                <v-date-picker name="date" id="date" v-model="birthdate" required />
              </div>

              <label for="email">Email</label>
              <input type="email" name="email" id="email" v-model="email" required />

              <label for="phone">Téléphone</label>
              <input type="tel" name="phone" id="phone" v-model="phone" required />

              <label for="password">Mot de passe</label>
              <input type="password" name="password" id="password" v-model="password" required />

            </div>
          </div>

          <div class="small-12 medium-5 cell">
            <div class="form ">

              <div class="line">
                <label for="prenom">Souhaitez-vous rendre la bibliothèque de ressources documentaires accessibles à {{ first_name }} :</label>
                <div class="box-radio">
                  <input type="radio" name="can_read_documents" value="true" v-model="can_read_documents">
                  <label>Oui</label>
                </div>
                <div class="box-radio">
                  <input type="radio" name="can_read_documents" value="false" v-model="can_read_documents">
                  <label>Non</label>
                </div>
              </div>
              <div class="line" v-if="currentUser.account_type === 'relative'">
                <label for="prenom">Souhaitez-vous rendre accessible le rapport d’humeur à {{ first_name }} :</label>
                <div class="box-radio">
                  <input type="radio" name="can_see_mood" value="true" v-model="can_see_mood">
                  <label>Oui</label>
                </div>
                <div class="box-radio">
                  <input type="radio" name="can_see_mood" value="false" v-model="can_see_mood">
                  <label>Non</label>
                </div>
              </div>

            </div>
          </div>

          <div class="small-12 medium-3 cell">
            <ul class="nav-dashbord">
              <li class="deleted" v-if="currentUser.account_type === 'relative'"><a @click="deleteUser"><i class="fas fa-trash-alt"></i>Supprimer le compte de {{ first_name }}</a></li>
            </ul>
          </div>

          <div class="small-12 medium-12 center cell">
            <hr>
            <input class="button btnPush" name="submit" type="submit" value="Enregistrer les modifications" @click="send" @mouseover="verify"/>
          </div>

      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import {  } from 'vuex'
  import { dateFromString } from '@/functions'
  import { mapGetters, mapActions, mapState } from 'vuex'

  export default {
    props: ['id'],
    components: { TitlePage, Bouton },
    data () {
      let current_user = this.$store.getters.subAccount(this.id)

      return {
        identifier: current_user.identifier,
        first_name: current_user.first_name,
        last_name: current_user.last_name,
        birthdate:  dateFromString(current_user.birthdate),
        email: current_user.email,
        phone: current_user.phone,
        password: "",
        mail_appointment: current_user.notif_mail.indexOf('appointment') !== -1,
        sms_appointment: current_user.notif_sms.indexOf('appointment') !== -1,
        mail_community: current_user.notif_mail.indexOf('community') !== -1,
        sms_community: current_user.notif_sms.indexOf('community') !== -1,
        can_read_documents: (current_user.rights && current_user.rights.indexOf('read_documents')) !== -1 ? true : false,
        can_see_mood: current_user.rights && current_user.rights.indexOf('see_mood') !== -1 ? true : false,
        errors: []
      }
    },
    computed: {
      currentUser() {
        return this.$store.getters.subAccount(this.id)
      }
    },
    methods: {
      ...mapActions(['updateSub', 'deleteRelative', 'addNotice']),
      verify () {
        this.errors = []
        if (!this.first_name) {
          this.errors.push("firstname")
        }
        if (!this.last_name) {
          this.errors.push("lastname")
        }
      },
      async deleteUser (e) {
        try {
          this.deleteRelative(this.id)
          this.addNotice({ message: `Le compte de votre proche a été supprimé avec succès.` })
          this.$router.push({name: 'dashboard'})
        } catch (ex) {
          console.log(ex)
        }

      },
      async send (e) {
        e.preventDefault();
        this.verify();
        if (this.errors.length > 0) {
          return false
        }

        let notif_mail = []
        if (this.mail_appointment)
          notif_mail.push('appointment')
        if (this.mail_community)
          notif_mail.push('community')

        let notif_sms = []
        if (this.sms_appointment)
          notif_sms.push('appointment')
        if (this.sms_community)
          notif_sms.push('community')

        let permissions = []
        if (this.can_see_mood === "true") {
          permissions.push('see_mood');
        }
        if (this.can_read_documents === "true") {
          permissions.push('read_documents');
        }


        try {
          let userCommit = {
            id: this.id,
            first_name: this.first_name,
            last_name: this.last_name,

            email: this.email,
            phone: this.phone,
            notif_mail: JSON.stringify(notif_mail),
            notif_sms: JSON.stringify(notif_sms),
            permissions: permissions,
          }

          if (this.password) {
            userCommit.password = this.password
          }

          if (this.birthdate) {
            userCommit.birthdate = this.birthdate.toISOString().split('T')[0]
          }

          this.updateSub({ userCommit })
          this.addNotice({ message: `Félicitations ! L'enregistrement du compte pour <strong>${this.first_name}</strong> est réalisé avec succès.` })
          this.$router.push({name: 'dashboard'})
        } catch (ex) {
          console.log(ex)
        }
      }

    }
  }
</script>
